import { FC } from 'react';

import { DividendHooks, useSelectedCompany } from '../../../hooks/index';
import { useScreenSize } from '../../../hooks/use-screen-size.hook';
import { getTranslation } from '../../../utils/get-translation.util';
import { SummaryItem } from '../../cap-table/summary-item';
import { formatDividendAmount } from '../utils/format-dividend-amount.util';

type Props = {
  companyId: string;
};

export const DividendsStatsStrip: FC<Props> = ({ companyId }) => {
  const { selectedCompany } = useSelectedCompany();
  const currencySymbol = selectedCompany?.currency?.symbol ?? '';

  const { stats } = DividendHooks.useDividendStats({ companyId });
  const { width } = useScreenSize();
  const isPhone = width < 460;

  const formatAmount = (value: number) => `${currencySymbol}${formatDividendAmount(value)}`;

  return (
    <div className="flex w-full flex-1 flex-col gap-3 rounded-lg bg-gray-50 px-1 pb-1 pt-3">
      <div className="flex h-9 items-center px-4">
        <span className="text-[10px] font-bold uppercase leading-4 tracking-[1px] text-gray-700">
          {getTranslation(isPhone ? 'OWNERSHIP_SUMMARY' : 'OVERALL_STATUS')}
        </span>
      </div>
      <div className="grid h-full w-full grid-cols-2 content-start gap-3 rounded-md bg-white p-3 shadow-sm max-xs:grid-cols-1">
        <SummaryItem
          title={getTranslation('TOTAL_DIVIDENDS_PAID_OUT')}
          value={stats ? formatAmount(stats.totalPayout) : '—'}
        />
        <SummaryItem title={getTranslation('TOTAL_PAYOUTS')} value={stats?.payoutsCount ?? '—'} />
        <SummaryItem
          title={getTranslation('SHARE_CLASSES_WITH_DIVIDEND_RIGHT')}
          value={stats?.shareClassesCount ?? '—'}
        />
        <SummaryItem
          title={getTranslation('STAKEHOLDERS_WITH_DIVIDEND_RIGHT')}
          value={stats?.stakeholdersCount ?? '—'}
        />
        <div className="col-span-2 max-xs:col-span-1">
          <SummaryItem
            title={getTranslation('LAST_PERIOD_DIVIDENDS')}
            value={stats ? formatAmount(stats.lastPeriodDividends) : '—'}
          />
        </div>
      </div>
    </div>
  );
};
